import authReducer from '@socgress/lib/store/actions/auth';

export default authReducer;
